// extracted by css-extract-rspack-plugin
export default {"selectionAnchor":"Mg8Q9V1288aR0fLR","selectionPopover":"jI7o1DtpTygNThHe","selectionFeedback":"dSNkNvO6QBxmIwZ7","selectionInput":"TpcTdIDjzf0kF3j3"};